import type { BlockEditFormState } from '@ContractBuilder/modules/block-edit';
import type { ResourceBlock } from '@domain/schemas/contract.schema';
import { useAllTeams } from '@queries/fetchTeams';
import { isBlockInactive } from '@root/helpers/blocks';
import { isBlockNotYetActive } from '@root/helpers/blocks/is-block-inactive';

import { getHideSection } from '../utils/get-hide-section';

interface UseBlockDetailsArgs {
  currentBlock?: ResourceBlock;
  formValues?: BlockEditFormState;
  isAdminView: boolean;
  submissionCreatedAt?: string;
}

export const useBlockDetails = ({
  currentBlock,
  formValues,
  isAdminView,
  submissionCreatedAt,
}: UseBlockDetailsArgs) => {
  const { data: teams = [], isFetching: isFetchingTeams } = useAllTeams();

  const blockUpdatedAt = formValues?.updated_at ?? formValues?.created_at;
  const blockUpdatedByName = (formValues?.last_updated_by ?? formValues?.created_by)?.name;
  const hasBlockBeenUpdatedOnContract = Boolean(
    !isAdminView && submissionCreatedAt && blockUpdatedAt && submissionCreatedAt < blockUpdatedAt,
  );

  return {
    teams,
    isFetchingTeams,
    blockUpdatedAt,
    blockUpdatedByName,
    hasBlockBeenUpdatedOnContract,
    isHidden: getHideSection(isAdminView, formValues) && !hasBlockBeenUpdatedOnContract,
    blockStatus: {
      isArchived: !!currentBlock?.deleted_at,
      isInactive: isBlockInactive(currentBlock?.inception_date, currentBlock?.expiry_date),
      isNotYetActive: isBlockNotYetActive(currentBlock?.inception_date),
    },
  };
};

export type BlockDetails = ReturnType<typeof useBlockDetails>;
